/* eslint-disable import/prefer-default-export */
/**
 * Utility to construct endpoint URL
 */

export const constructEndpointUrl = (endpoint: string): string =>
  // Remove trailing slash if present
  endpoint.replace(/\/$/, '');
